import React from 'react';

import LoadingSection from 'components/LoadingSection';
import Layout from 'layouts/Layout';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const LoadingPage = ({
  delay,
  navSection,
}: {
  delay?: number;
  navSection?: 'MAIN' | 'STAFF';
}) => (
  <Layout navSection={navSection}>
    <LoadingSection delay={delay} />
  </Layout>
);

// eslint-disable-next-line import/no-default-export
export default LoadingPage;
